import {Component, OnInit, signal} from '@angular/core';
import {CustomerArea} from '../classes/customerarea.class';
import {CustomerAreaService} from '../services/consumer-area/customer-area.service';
import {combineLatest} from 'rxjs';
import {Status, StatusId} from '../classes/status.class';
import {StatusService} from '../services/status/status.service';
import {PricesService, PriceType} from '../services/prices/prices.service';
import {PushpinService} from '../services/pushpin/pushpin.service';
import {MaterialService} from '../services/material/material.service';
import {DecorationsService} from '../services/decorations/decorations.service';
import {PaintColorService} from '../services/paintColor/paint-color.service';
import {PushpinPart} from '../classes/pushpinpart.class';
import {MaterialPrice} from '../classes/materialprice.class';
import {DecorationPrice} from '../classes/decorationprice.class';
import {ExtraCostsService} from '../services/extraCosts/extra-costs.service';
import {ExtraCost} from '../classes/extracost.class';
import {CodaltComponent} from '../codalt.component';
import {Material} from '../classes/material.class';
import {ExtraCostPrice} from '../classes/extracostprice.class';
import {MatFormField, MatLabel} from "@angular/material/input";
import {MatOptgroup, MatOption, MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";
import {RouterLink} from "@angular/router";
import {TotalPricePushpinPartsPipe} from "./total-price-pushpin-parts.pipe";
import {DecimalPipe} from "@angular/common";
import {TotalPriceExtraCostsPipe} from "./total-price-extra-costs.pipe";
import {TotalCountPushpinPartsPipe} from "./total-count-pushpin-parts.pipe";
import {PercentCountPipe} from "./percent-count.pipe";
import {TotalSurfacePushpinPartsPipe} from "./total-surface-pushpin-parts.pipe";
import {PercentSurfacePipe} from "./percent-surface.pipe";
import {PercentPricePipe} from "./percent-price.pipe";

class stat {
    count: number;
    customer_area_id: number;
    status_id: number;
    type: string;
    name: string;
    surface: number;
    length: number;
    price: number;
}

class statMaterial {
    name: string;
    stat_free: stat;
    stat_executed: stat;
    stat_paid: stat;
    percentageCount: number;
    percentageSurface: number;
    percentagePrice: number;
}

class statCustomerArea {
    name: string;
    materials: statMaterial[];
}

class statType {
    priceType: PriceType;
    name: string;
    color: string;
    ca?: statCustomerArea[];
}


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [
        MatFormField,
        MatLabel,
        MatSelect,
        FormsModule,
        MatOptgroup,
        MatOption,
        RouterLink,
        TotalPricePushpinPartsPipe,
        DecimalPipe,
        TotalPriceExtraCostsPipe,
        TotalCountPushpinPartsPipe,
        PercentCountPipe,
        TotalSurfacePushpinPartsPipe,
        PercentSurfacePipe,
        PercentPricePipe
    ]
})
export class DashboardComponent extends CodaltComponent implements OnInit {

    readonly filter = signal([]);
    readonly types = signal([
        {
            priceType: PriceType.notSpecific,
            name: 'Figuratie',
            color: '#d6dce4'
        },
        {
            priceType: PriceType.specific,
            name: 'Lengtemarkering',
            color: '#ededed'
        }
    ] as statType[]);
    readonly allMaterials = signal<Material[]>(null);
    readonly materials = signal<Material[]>(null);

    readonly allCustomerAreas = signal<CustomerArea[]>(null);
    readonly customerAreas = signal<CustomerArea[]>(null);
    readonly stats = signal<any>(null);
    readonly highlightCa = signal<any>(null);
    readonly statuses = signal<Status[]>(null);
    readonly showPrice = signal<boolean>(true);
    readonly showCount = signal<boolean>(true);
    readonly showSurface = signal<boolean>(true);
    readonly showRevenue = signal<boolean>(true);
    readonly showEmptyCas = signal<boolean>(true);
    readonly showMaterialSpecific = signal<boolean>(true);
    readonly visibleCas = signal([]);
    readonly showInspectionsFor = signal<CustomerArea>(null);

    readonly pushpinParts = signal<PushpinPart[]>(null);
    readonly extraCosts = signal<ExtraCost[]>(null);

    readonly materialPrices = signal<MaterialPrice[]>(null);
    readonly decorationPrices = signal<DecorationPrice[]>(null);
    readonly extraCostsPrices = signal<ExtraCostPrice[]>(null);
    SpecificPrice = PriceType;

    constructor(
        private customerAreaService: CustomerAreaService,
        private pricesService: PricesService,
        private pushpinService: PushpinService,
        private extraCostsService: ExtraCostsService,
        private statusService: StatusService,
        private materialService: MaterialService,
        private decorationsService: DecorationsService,
        private paintColorService: PaintColorService
    ) {
        super();
    }

    mousen(ca: any) {
        this.highlightCa.set(ca);
    }

    updateFilter(evt) {
        this.showCount.set(evt.indexOf('count') !== -1);
        this.showSurface.set(evt.indexOf('surface') !== -1);
        this.showPrice.set(evt.indexOf('price') !== -1);
        this.showRevenue.set(evt.indexOf('revenue') !== -1);
        this.showEmptyCas.set(evt.indexOf('emptyCas') !== -1);
        this.showMaterialSpecific.set(evt.indexOf('materialSpecific') !== -1);
        this.visibleCas.set([]);
        this.filterCustomerAreas();
        this.filterMaterials(evt.filter(e => typeof e === 'number'));
    }

    ngOnInit(): void {
        this.filter.set(['revenue', 'surface', 'price', 1, 2]);
        this.filter.set(this.filter().concat(this.materials()));
        this.updateFilter(this.filter());

        const statusMap$ = this.statusService.getKeyValMap();
        const decorationsMap$ = this.decorationsService.getKeyValMap();
        const materialsMap$ = this.materialService.getMaterialsAsKeyValueMap(true);
        const paintColorMap$ = this.paintColorService.getKeyValMap();
        const materials$ = this.materialService.getMaterials(true);
        const pushpinParts$ = this.pushpinService.allInspectionPushpins();
        const extraCosts$ = this.extraCostsService.getAllExtraCosts();
        const extraCostsMap$ = this.extraCostsService.getKeyValMap();
        const prices$ = this.pricesService.getPrices();
        const customerAreas$ = this.customerAreaService.getAllCustomerAreas();


        this.statusService.getStatuses().then(statuses => {
            this.statuses.set(statuses.filter(s => s.id !== StatusId.GeschouwdDoorKlant));
        });

        this.materialService.getMaterials().then(materials => {
            this.materials.set(materials);
            this.allMaterials.set(materials);
        });

        this.subscriptions.add(combineLatest(pushpinParts$, extraCosts$, prices$, statusMap$, decorationsMap$, materialsMap$, paintColorMap$, extraCostsMap$, materials$, customerAreas$)
            .subscribe(([allPushpins, extraCosts, allPriceData, status, decoration, material, paintColor, extraCostsMap, materials, customerAreas]) => {
                allPushpins.data.forEach(pushpinPart => {
                    pushpinPart.decoration = decoration[pushpinPart.decoration_id];
                    pushpinPart.material = decoration[pushpinPart.material_id];
                    pushpinPart.paint_color = decoration[pushpinPart.paint_color_id];
                    pushpinPart.status = decoration[pushpinPart.status_id];
                    pushpinPart.amount = +pushpinPart.amount;
                    pushpinPart.surface = +pushpinPart.surface;
                    pushpinPart.length = +pushpinPart.length;
                    pushpinPart.stake_out = !!pushpinPart.stake_out;
                    pushpinPart.exclusive_material = !!pushpinPart.exclusive_material;
                    pushpinPart.blast = !!pushpinPart.blast;
                    pushpinPart.night = !!pushpinPart.night;
                });
                this.pushpinParts.set(allPushpins.data);
                this.materialPrices.set(allPriceData.data.materialPrices);
                this.decorationPrices.set(allPriceData.data.decorationPrices);
                this.extraCostsPrices.set(allPriceData.data.extraCostPrices);
                this.allCustomerAreas.set(
                    customerAreas.sort((a, b) => {
                        return a.name.localeCompare(b.name);
                    })
                );
                this.filterCustomerAreas();

                extraCosts.data.forEach(extraCost => {
                    extraCost.extra_cost_type = extraCostsMap[extraCost.extra_cost_type_id];
                    extraCost.number = +extraCost.number;
                });
                this.extraCosts.set(extraCosts.data);
            }));
    }

    private filterCustomerAreas() {
        if (this.showEmptyCas()) {
            this.customerAreas.set(this.allCustomerAreas());
        } else {
            this.customerAreas.set(this.allCustomerAreas()?.filter(c => !!this.pushpinParts().find(p => p.customer_area_id === c.id)));
        }
    }

    private filterMaterials(materialIds: number[]) {
        if (!materialIds?.length) {
            this.materials.set(this.allMaterials());
        } else {
            this.materials.set(this.allMaterials()?.filter(m => materialIds.includes(m.id)));
        }
    }

    readonly StatusId = StatusId;
}
